export default [
    {
        path: "/training/grenade-firing",
        component: () => import("@/App/Training/GrenadeFiring/Components/List.vue"),
        name: "training-grenade-firing-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/grenade-firing/create",
        component: () => import("@/App/Training/GrenadeFiring/Components/Create.vue"),
        name: "training-grenade-firing-create",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/grenade-firing/detail-list",
        component: () => import("@/App/Training/GrenadeFiring/Components/DetailList.vue"),
        name: "training-grenade-detail-list",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/grenade-firing/detail",
        component: () => import("@/App/Training/GrenadeFiring/Components/DetailCreate.vue"),
        name: "training-grenade-detail",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/training/grenade-firing/detail-edit/:id",
        component: () => import("@/App/Training/GrenadeFiring/Components/DetailEdit.vue"),
        name: "training-grenade-detail-edit",
        meta: {
            requiresAuth: true,
        },
    },
];
